export const privacyPolicyPersonalData = 'https://www.alean.ru/page/privacy_policy_personal_data';
export const privacyPolicy = 'https://www.alean.ru/page/privacy-policy';
